module.exports = __webpack_public_path__ + "static/media/medal.39487c41.png";